var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.profileBlock},[_c('icon',{class:_vm.$style.icon,attrs:{"name":"lock","width":"80","height":"90","color":"#E5E3E3"}}),_c('div',{class:_vm.$style.desc},[_vm._v(_vm._s(_vm.$t('block.app.profile')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }